export const STATION_LOADING = "charger/station/loading";
export const STATION_ERROR = "charger/station/error";
export const STATION_LIST = "charger/station/list";
export const STATION_FILTERS = "charger/station/filters";



// WEBPACK FOOTER //
// ./src/actions/chargers/station/constants.js